export default {"src":"https://fishbrain.com/_next/static/media/bragIconBests.4b9cab62.svg","height":51,"width":68,"blurWidth":0,"blurHeight":0};